import * as React from 'react'
import { notificationLightBlue, notificationLightGreen, notificationLightRed } from '../../styles/material-ui-theme-v2'
import makeStyles from '@material-ui/core/styles/makeStyles'

export type TNotificationType = 'warning' | 'success' | 'info'

export interface INotificationProps {
  children: React.ReactNode
  type: TNotificationType
  className?: string
}

const useStyles = makeStyles((theme) => ({
  wrapper: {
    padding: '14px',
    marginBottom: '24px',
    borderRadius: '8px',
    [theme.breakpoints.up('md')]: {
      padding: '16px',
    },
  },
  text: {
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '17px',
    color: 'rgba(36, 40, 78, 0.7)',
    [theme.breakpoints.up('md')]: {
      fontSize: '14px',
    },
  },

  warning: {
    backgroundColor: notificationLightRed,
  },
  success: {
    backgroundColor: notificationLightGreen,
  },
  info: {
    backgroundColor: notificationLightBlue,
  },
}))

export default function Notification(props: INotificationProps) {
  const { children, type, className } = props
  const classes = useStyles()

  const BEM = (): string => {
    const classArray = [classes.wrapper]

    switch (type) {
      case 'warning':
        classArray.push(classes.warning)
        break
      case 'success':
        classArray.push(classes.success)
        break
      case 'info':
        classArray.push(classes.info)
        break
    }

    if (className) {
      classArray.push(className)
    }

    return classArray.join(' ')
  }

  return (
    <div className={BEM()}>
      <div className={classes.text}>{children}</div>
    </div>
  )
}
